import React from 'react';
import { Input, InputAdornment } from '@material-ui/core';
import _ from 'root/libs/exaforte/react/lodash';
import CustomFormInput from './CustomFormInput';

export default class CustomTextField extends CustomFormInput {
    getSupportedProps() {
        return {...super.getSupportedProps(), ..._.filterSupportedProps(this.props, {multiline: true, rows: true, fullWidth: true, inputProps: true, type: true, startAdornment: true, endAdornment: true, inputRef: true, autoFocus: true, autoComplete: true })};
    }
    
    getElement() {
        let props = this.getSupportedProps();

        if(_.is_empty(props.value))
            props.value = '';

        if(this.props.is_uncontrolled)
        {
            props.defaultValue = props.value; // Zodat we een uncontrolled input gebruiken. Op dit moment is er veel laggggg wanneer je typt bij een grote dom.

            delete props.value;
        }
        
        if (props.endAdornment && typeof props.endAdornment === 'string') {
            props.endAdornment = (
                <InputAdornment 
                    position="end" 
                    style={{ color: '#000', marginLeft: '8px' }}
                >
                    {props.endAdornment}
                </InputAdornment>
            );
        }

        return <Input autoComplete="off" disableUnderline={true} onChange={this._onChange} {...props} />;
    }
}